import { type ModalProps } from '@doxyme/ui/components/foundations';
import { useViewport } from '@doxyme/ui/hooks';
import { useTheme } from '@doxyme/ui/theme';
import { type CSSObject } from '@emotion/react';

export const useInviteViaEmailFormStyles = (): ModalProps['styles'] & {
  readOnlyTextbox: {
    wrapper: CSSObject;
    defaultMessage: CSSObject;
    staticContent: CSSObject;
  };
} => {
  const { isSmallViewport } = useViewport();
  const theme = useTheme();

  return {
    ...(!isSmallViewport && {
      submitButton: {
        flex: 'initial',
        minWidth: 142,
      },
    }),
    readOnlyTextbox: {
      wrapper: {
        position: 'relative',
        overflow: 'hidden',
        borderRadius: theme.shape.radius8,
        outline: '0px solid transparent',
        border: `1px solid transparent`,
        boxShadow: `${theme.typography.inputShadow}, 0 0 0 1px ${theme.input.border.default}`,
        backgroundColor: theme.input.background.disabled,
      },
      defaultMessage: {
        padding: theme.spacing(3),
        color: theme.text.generic.primary,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      },
      staticContent: {
        padding: theme.spacing(3),
        background: theme.input.background.disabled,
        borderTop: `1px solid ${theme.border.primary}`,
        color: theme.text.generic.tertiary,
        whiteSpace: 'pre-wrap',
      },
    },
  };
};
